<template>
  <v-card>
    <v-container>
      <v-row>
        <v-col>
          {{confirmationText}}
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn color="success" @click="handleClick(true)" text>Yes</v-btn>
          <v-btn color="error"  @click="handleClick(false)" text>No</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: 'ConfirmModal',
  props: {
    confirmationText: String
  },
  methods: {
    handleClick (val) {
      this.$emit('dialog-clicked', val)
    }
  }
}
</script>
